import { render } from "./pagePromotion.vue?vue&type=template&id=c26ba34c&scoped=true"
import script from "./pagePromotion.vue?vue&type=script&lang=js"
export * from "./pagePromotion.vue?vue&type=script&lang=js"

import "./pagePromotion.vue?vue&type=style&index=0&id=c26ba34c&lang=scss"
import "./pagePromotion.vue?vue&type=style&index=1&id=c26ba34c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c26ba34c"]])

export default __exports__